export type VehicleOwnershipType = 'owned' | 'leased' | 'lease_ended';

export function resolveOwnershipType(
  type: string | null | undefined,
  rentEnd?: string | null
): VehicleOwnershipType | null {
  if (type === 'owned') return 'owned';
  if (type === 'lease_ended') return 'lease_ended';
  if (type === 'leased') {
    const end = rentEnd ? String(rentEnd).slice(0, 10) : '';
    const today = new Date().toISOString().slice(0, 10);
    return end && end < today ? 'lease_ended' : 'leased';
  }
  return null;
}

export function isCarInfoLeasingActive(active: unknown): boolean {
  const s = String(active ?? '').trim().toLowerCase();
  return s === 'yes' || s === 'true' || s === 'ja' || s === '1';
}

export function ownershipLabelKey(type: VehicleOwnershipType): string {
  switch (type) {
    case 'owned':
      return 'fleet.ownershipOwned';
    case 'leased':
      return 'fleet.ownershipLeased';
    case 'lease_ended':
      return 'fleet.ownershipLeaseEnded';
    default: {
      const _exhaustive: never = type;
      return _exhaustive;
    }
  }
}
